import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const getChargerTypeMetaData: UseCase<ChargerRepository, 'getChargerTypeMetaData'> = repository => {
  return async chargerModel => {
    return await repository.getChargerTypeMetaData(chargerModel)
  }
}
